import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import { createFragmentContainer, graphql } from 'react-relay';

import { getValidRespAppliedFilters } from '../SbRespRefineMenu/SbRespRefineMenuFilters/sbRespRefineMenuFiltersMap';
import { clearAllAppliedFiltersHandler } from '../SbSharedAppliedFilters/sbSharedAppliedFiltersHelpers';
import { SbRespRefineMenuDrawerHeader_itemSearch } from './__generated__/SbRespRefineMenuDrawerHeader_itemSearch.graphql';

import styles from './SbRespRefineMenuDrawerHeader.scss';

type Props = {
    itemSearch: SbRespRefineMenuDrawerHeader_itemSearch;
};

const SbRespRefineMenuDrawerHeaderComponent: FC<Props> = ({ itemSearch }) => {
    const dispatch = useDispatch();
    const { appliedFilters } = itemSearch;
    const hasAppliedFilters = appliedFilters
        ? getValidRespAppliedFilters({ appliedFilters }).length
        : false;
    return (
        <div className={styles.header}>
            <span className={styles.title}>
                <FormattedMessage
                    id="SbRespRefineMenuDrawerHeader.title"
                    defaultMessage="All Filters"
                />
            </span>
            {hasAppliedFilters && (
                <span
                    className={styles.subtitleCta}
                    onClick={clearAllAppliedFiltersHandler(dispatch, { itemSearch })}
                >
                    <FormattedMessage
                        id="SbRespRefineMenuDrawerHeader.subtitleCta"
                        defaultMessage="Clear All"
                    />
                </span>
            )}
        </div>
    );
};

export const SbRespRefineMenuDrawerHeader = createFragmentContainer(
    SbRespRefineMenuDrawerHeaderComponent,
    {
        itemSearch: graphql`
            fragment SbRespRefineMenuDrawerHeader_itemSearch on ItemSearchQueryConnection {
                clearAppliedFiltersLinkReference
                appliedFilters {
                    canBeDismissed
                }
            }
        `,
    }
);
